import { call, put, takeLatest, delay } from 'redux-saga/effects';

import api from '~/services/api';
import { getCompany, getCompanySuccess, getCompanyFailure } from '.';
import { selectCompany } from './selectors';

export default function* rootSaga() {
	yield takeLatest(getCompany, getCompanySaga);
}

function* getCompanySaga({ payload }) {
	try {
		yield delay(500);
		const { data } = yield call(api.get, `/companies/slug/${payload}`);
		yield put(getCompanySuccess(selectCompany(data.data)));
	} catch (error) {
		yield put(getCompanyFailure(error.response.data.error));
	}
}
